import { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import { api, setToken } from "@/lib/auth";

export default function AdminVerify() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [state, setState] = useState("loading"); // loading, success, error
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    const token = params.get("token");
    if (!token) {
      setState("error");
      setErrorMsg("Manglende token");
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/verify", { token });
        setToken(data.token);
        setState("success");
        setTimeout(() => navigate("/admin", { replace: true }), 800);
      } catch (e) {
        setState("error");
        setErrorMsg(e?.response?.data?.detail || "Ugyldigt eller udløbet link");
      }
    })();
  }, [params, navigate]);

  return (
    <div className="min-h-screen bg-brand-bg grid place-items-center px-6 py-12" data-testid="admin-verify-page">
      <div className="w-full max-w-md bg-brand-surface rounded-3xl border border-brand-border p-10 text-center">
        {state === "loading" && (
          <>
            <Loader2 className="h-10 w-10 text-brand-primary animate-spin mx-auto" />
            <h1 className="font-display text-2xl tracking-tight text-brand-text mt-6">Verificerer login...</h1>
          </>
        )}
        {state === "success" && (
          <>
            <div className="h-14 w-14 rounded-full bg-brand-primary/10 grid place-items-center mx-auto">
              <CheckCircle2 className="h-8 w-8 text-brand-primary" />
            </div>
            <h1 className="font-display text-2xl tracking-tight text-brand-text mt-6">Logget ind</h1>
            <p className="text-sm text-brand-muted mt-2">Sender dig videre til portalen...</p>
          </>
        )}
        {state === "error" && (
          <>
            <div className="h-14 w-14 rounded-full bg-red-50 grid place-items-center mx-auto">
              <XCircle className="h-8 w-8 text-red-500" />
            </div>
            <h1 className="font-display text-2xl tracking-tight text-brand-text mt-6">Login mislykkedes</h1>
            <p className="text-sm text-brand-muted mt-2">{errorMsg}</p>
            <Link
              to="/admin/login"
              data-testid="admin-verify-retry"
              className="mt-6 inline-flex rounded-full bg-brand-primary text-brand-bg px-5 py-2.5 text-sm font-medium hover:bg-brand-hover"
            >
              Prøv igen
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
